import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { SxHttpService } from './sxHttp.service';
import { Sponsor } from './assets.service';

export interface PublishPortal {
  id?: string;
  alias: string;
  organizationCode: string;
  subscriptionCode: string;
  channelCode: string;
  setting: SettingPublishPortal;
}

export interface Portals {
  publishPortalB2B: PublishPortal[];
  publishPortalB2C: Sponsor[];
}
export interface SettingPublishPortal {
  portalType: string;
  productCode: string;
  flowCode: string;
  flowId: string;
  description: string;
  username: string;
  customUrl: string;
}

export interface PortalFlow {
  flowId: string;
  flowCode: string;
}

export const TYPE_PRODUCT_FLOW: string = 'ProductFlow';
export const TYPE_NON_TRANSACTIONAL_FLOW: string = 'NonTransactionalFlow';
export const TYPE_NON_PRODUCT: string = 'NONE';

@Injectable()
export class PublishPortalService {
  private serviceUrl = 'api/configurationPortal';

  constructor(private sxHttp: SxHttpService) {}

  getPortalbyAlias(alias: string): Observable<PublishPortal> {
    return this.sxHttp.get(`${this.serviceUrl}/${alias}`).map((response) => response.json().data as PublishPortal);
  }

  getAllPortals(): Observable<Portals> {
    return this.sxHttp.get(this.serviceUrl + '/GetAllPortals').map((response) => response.json().data as Portals);
  }

  getPortalsByContext(
    subscriptionCode: string,
    channelCode: string
  ): Observable<PublishPortal[]> {
    return this.sxHttp
      .get(this.serviceUrl + '/' + subscriptionCode + '/' + channelCode)
      .map((response) => response.json().data as PublishPortal[]);
  }

  savePortalsB2C(portal: PublishPortal): Promise<PublishPortal> {
    return this.sxHttp
      .post(this.serviceUrl, portal)
      .toPromise()
      .then((response) => response.json().data as PublishPortal)
      .catch(this.handleError);
  }

  updatePortalsB2C(portal: PublishPortal): Promise<PublishPortal> {
    return this.sxHttp.post(`${this.serviceUrl}/edit/${portal.alias}`, portal)
      .toPromise()
      .then((response) => response.json().data as PublishPortal)
      .catch(this.handleError);
  }

  DeletePortal(id: string): Promise<any> {
    return this.sxHttp
      .delete(this.serviceUrl + '/' + id)
      .toPromise()
      .then((response) => response.json().data)
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('Ocurrió un error', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/publishPortal.service.ts